var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-row',[_c('mdb-col',[(_vm.loadReady)?_c('mdb-select',{attrs:{"search":"","visibleOptions":6,"label":_vm.$t('unionmember'),"placeholder":_vm.$t('choose_unionmember')},on:{"getValue":_vm.getSelectValue},model:{value:(_vm.labelOptions),callback:function ($$v) {_vm.labelOptions=$$v},expression:"labelOptions"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }